$(document).ready(function(){
    $('[data-interactive-table-tab]').on('click', function(){

        let clicked = $(this).attr('data-interactive-table-tab');
        $('[data-interactive-table-tab]').removeClass("interactive-table__tab--active");
        $('[data-interactive-table-page]').removeClass("interactive-table__page--active");

        $(`[data-interactive-table-page='${clicked}']`).addClass("interactive-table__page--active");
        $(this).addClass("interactive-table__tab--active");
    });
});
